import { createSlice } from "@reduxjs/toolkit";

export const Report = createSlice({
    name:"ReportSlice",
    initialState:{
        StockMove:undefined,
        StockMoveSingle:[],
        IAreport:undefined
    },
    reducers:{
        setStockMove:(state,action)=>{
            state.StockMove = action.payload.stockMoveList
        },
        setStockMoveSigleView:(state,action)=>{
            state.StockMoveSingle = action.payload.stockMoveSingleList
        }, 
       getIAreportList:(state,action)=>{
            state.IAreport = action.payload.iaReportList
        },  

    }
})
export const {setStockMove,setStockMoveSigleView,getIAreportList}=Report.actions;
export default Report.reducer;